import { LinkField } from 'components';
import { useIsFormEditable } from 'hooks';
import { useTranslation } from 'libs/i18n';
import { generatePath, ROUTES } from 'libs/navigation';
import { Input } from 'libs/ui';
import { OrderAutocompleteFeature } from 'modules/operation/common/features';
import { useField } from 'modules/operation/common/forms/operationForm';

interface OrderFieldProps {
  disabled?: boolean;
}

export const OrderField = ({ disabled }: OrderFieldProps) => {
  const { t } = useTranslation();

  const editable = useIsFormEditable();

  const { field: clientField } = useField('client');
  const { field: clientTypeField } = useField('clientType');
  const { field: orderField } = useField('order');

  if (!clientTypeField?.value?.value || !clientField?.value?.value) {
    return (
      <Input
        showRequiredMark
        disabled={editable}
        label={t('operation.sections.clientsOrderSection.fields.order.label')}
        placeholder={t(
          'operation.sections.clientsOrderSection.fields.order.placeholder'
        )}
      />
    );
  }

  if (editable) {
    if (disabled) {
      return (
        <Input
          disabled
          showRequiredMark
          label={t('operation.sections.clientsOrderSection.fields.order.label')}
          value={orderField?.value?.label || ''}
        />
      );
    }
    return (
      <OrderAutocompleteFeature
        clientId={clientField.value.value}
        clientType={clientTypeField.value.value}
        disabled={disabled}
      />
    );
  }

  return (
    <LinkField
      label={t('operation.sections.clientsOrderSection.fields.order.label')}
      link={generatePath(ROUTES.orders.order.fullPath, {
        orderId: orderField?.value?.value ?? '',
      })}
      value={orderField?.value?.label!}
    />
  );
};
